// extracted by mini-css-extract-plugin
export default {"categoryContainer":"Categories_categoryContainer__EI4xv","categoryInner":"Categories_categoryInner__3HETW","role":"Categories_role__5cnso"};